import { Controller } from "react-hook-form";
import styled from "styled-components";
import { Pmb, P } from "./Typography";
import { forwardRef } from "react";
import { ErrorMessage } from '@hookform/error-message';
import theme from "../common/theme";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

const Input = styled.input`
    width: calc(100% - 2rem);
    outline: none;
    padding: 1rem;
    font-size: 1rem;
    background: ${theme.palette.light};
    border: 1px solid ${theme.palette.light};
    margin-top: 0.5rem;
    align-items: center;
    opacity: ${props => props.disabled ? 0.4 : 1};

    &::placeholder {
        font-family: "Roboto Condensed";
        color: ${theme.palette.dark};
        font-size: 14px;
    }
`

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
`

export const UncontrolledFormTextInput = forwardRef(({ errors, label, containerStyle, value, ...rest }, ref) => {
    let v = value ? new Date(value) : new Date();
    return (
        <Container style={containerStyle}>
            {label && <Pmb>{label}</Pmb>}
            <DatePicker
                customInput={<Input />}
                dateFormat="yyyy-MM-dd"
                selected={v}
                placeholderText={rest.placeholder}
                ref={ref}
                {...rest}
            />
            {errors && <ErrorMessage
                errors={errors}
                name={rest.name}
                render={({ message }) => <P style={{ color: 'red' }}>{message}</P>}
            />}
        </Container>
    )
})

export default ({ name, control, rules, ...rest }) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { ...fieldProps } }) => (
                <UncontrolledFormTextInput {...fieldProps} {...rest} />
            )}
        />
    );
};
